import rotator from "rotator";
import pie from "pistacja/plugin";
import typewriter from "typewriter";

pie.plugin(({ $ }) => {
  const searchboxTypewriter = typewriter($("#search"));
  const searcboxInput = $("#search + input[name=q]");

  searcboxInput.addEventListener("click", searchboxTypewriter.off);
  searcboxInput.addEventListener("paste", searchboxTypewriter.off);

  rotator($("*[data-rotator]"));
});
